import axios from "axios";
import * as actions from "../constants/cartConstants";
import config from "utils/config";
import { RentripsURL } from "utils/request";

// Dapetin semua barang yang ada di cart si user
// Datanya nanti bakal disimpen di local user
// METHOD GET, no params
export const getCart = () => async (dispatch: any, getState: any) => {
  try {
    dispatch({
      type: actions.CART_REQUEST,
    });

    const { token } = getState().userInfo.userInfo;

    const { data } = await axios.get(RentripsURL +`/api/user/cart/`, config(token));

    dispatch({
      type: actions.CART_REQUEST_SUCCESS,
      payload: data,
    });

    localStorage.setItem("cartItems", JSON.stringify(data));
  } catch (error: any) {
    dispatch({
      type: actions.CART_REQUEST_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Nambahin barang ke cart user
// METHOD POST
// Params: id, quantitiynya
export const addCart =
  (productId: string, days: number) => async (dispatch: any, getState: any) => {
    try {
      const { token } = getState().userInfo.userInfo;

      const { data } = await axios.post(
        RentripsURL +"/api/user/cart",
        {
          productId,
          days,
        },
        config(token)
      );

      dispatch({
        type: actions.CART_ADD_SUCCESS,
        payload: data,
      });
      localStorage.setItem("cartItems", JSON.stringify(data));
    } catch (error: any) {
      dispatch({
        type: actions.CART_ADD_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Update jumlah barang yang user pengen tambahin di cart
// METHOD PATCH
// Params: id, quantity
export const updateCart =
  (id: string, quantity: number) => async (dispatch: any) => {
    try {
      dispatch({
        type: actions.CART_UPDATE_REQUEST,
      });

      const { data } = await axios.patch(RentripsURL +"api/cart", {
        id,
        quantity,
      });

      dispatch({
        type: actions.CART_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      dispatch({
        type: actions.CART_UPDATE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Delete Barang dari cart si user
// METHOD DELETE
// Params:
export const deleteCart =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      const { token } = getState().userInfo.userInfo;

      const { data } = await axios.delete(
        RentripsURL +`/api/user/cart/${id}`,
        config(token)
      );
      dispatch({
        type: actions.CART_DELETE_SUCCESS,
        payload: data,
      });
      localStorage.setItem("cartItems", JSON.stringify(data));
    } catch (error: any) {
      dispatch({
        type: actions.CART_DELETE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
